/**
* this file contains the array for the topbar & left menu component
*
* Created by Tom on 28/5/17
*/

const menuItems = [
    {
        menuIcon: null,
        menuText: 'ABOUT',
        isExternal: false,
        route: '/about'
    },
    {
        menuIcon: null,
        menuText: 'FAQS',
        isExternal: false,
        route: '/faqs'
    },
    {
        menuIcon: null,
        menuText: 'HOW IT WORKS',
        isExternal: false,
        route: '/how-it-works'
    },
    {
        menuIcon: null,
        menuText: 'MY ACCOUNT',
        isExternal: false,
        route: '/account'
    },
    {
        menuIcon: null,
        menuText: 'SIGN OUT',
        isExternal: false,
        route: '/sign-out'
    }
]

export default menuItems



// WEBPACK FOOTER //
// ./src/components/TopBar/menuItems.js